export default __webpack_public_path__ + "static/media/Sattar.026cee15.png";